/**
 * RAL RANG JADVALI — rulon rangi 3D chizmada ko'rsatiladi.
 *
 * Nastroyka → Mahsulotlarda rulonga RAL kodi yoziladi (masalan RAL6005),
 * chizma oynasi shu yerdan hex rangni oladi.
 * Kod topilmasa — oddiy po'lat rangi ishlatiladi.
 */
export const RAL = {
	'RAL1001': '#c2b078',
	'RAL1014': '#e1cc4f',
	'RAL1015': '#e6d2b5',
	'RAL1018': '#f3e03b',
	'RAL2004': '#e75b12',
	'RAL3000': '#a72920',
	'RAL3005': '#59191f',
	'RAL3009': '#642424',
	'RAL3011': '#792423',
	'RAL3020': '#cc0605',
	'RAL5002': '#20214f',
	'RAL5005': '#1e2460',
	'RAL5010': '#006dd8',
	'RAL5012': '#0089b6',
	'RAL5015': '#2271b3',
	'RAL5021': '#07737a',
	'RAL6000': '#316650',
	'RAL6002': '#324f17',
	'RAL6005': '#2f4538',
	'RAL6011': '#6c7c59',
	'RAL6018': '#57a639',
	'RAL6020': '#37422f',
	'RAL6024': '#308446',
	'RAL6029': '#007243',
	'RAL7004': '#9c9c9c',
	'RAL7005': '#646b63',
	'RAL7016': '#293133',
	'RAL7024': '#474a51',
	'RAL7035': '#d7d7d7',
	'RAL7037': '#7d7f7d',
	'RAL8004': '#8e402a',
	'RAL8012': '#642424',
	'RAL8017': '#442f29',
	'RAL8019': '#3d3635',
	'RAL8025': '#755c48',
	'RAL9002': '#d7d5c9',
	'RAL9003': '#f4f4f4',
	'RAL9005': '#0a0a0a',
	'RAL9006': '#a5a5a5',
	'RAL9007': '#8f8f8c',
	'RAL9010': '#ffffff',
	'RAL9016': '#f6f6f6',
	'RAL9017': '#1e1e1e',
}

/** «RAL6005», «ral 6005», «6005» — hammasini tushunadi */
export function ralToHex(code) {
	if (!code) return null
	const k = String(code).toUpperCase().replace(/[^A-Z0-9]/g, '')
	if (RAL[k]) return RAL[k]
	if (/^[0-9]{4}$/.test(k) && RAL['RAL' + k]) return RAL['RAL' + k]
	return null
}

/** hex → [r,g,b] */
export function hexToRgb(hex) {
	const h = String(hex || '').replace('#', '')
	if (h.length !== 6) return null
	return [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16))
}

export const RAL_LIST = Object.keys(RAL).sort()

/* ═══════════ TUNUKA QALINLIGI ═══════════
   Rulon nomida yozib qo'yilgan bo'ladi, bir necha xil ko'rinishda:
     "9003/040 OQ RANG TMZ"  → /040  = 0.40 mm   (yuzdan bo'lak)
     "030/NERJAVEYKA TILLA"  → 030/  = 0.30 mm   (nom BOSHIDA)
     "QORA/2.00 mm QZQ"      → 2.00  = 2.00 mm   (to'g'ridan-to'g'ri)
     "APELSIN 035 XITOY"     → bo'sh joydan keyin
     "7024/04MOK MAT XTY"    → /04   = 0.40 mm   (nol tushib qolgan)
   Tegmasligi kerak bo'lganlar: "9003" (RAL kodi), "(1250)" (rulon eni).
   Topilmasa null qaytadi — chizmada standart qiymat ishlatiladi.
   150 ta haqiqiy rulon nomida sinalgan (6 ta tenant). */
export function thicknessFromName(name) {
	if (!name) return null
	const s = String(name)
	const take = raw => {
		let v = Number(raw) / 100
		// "04" kabi ikki xonali yozuv — 0.04 bo'lib ketmasin, 0.4 deb o'qiladi
		if (raw.length === 2 && v < 0.15) v = Number(raw) / 10
		return (v >= 0.1 && v <= 5) ? v : null
	}
	// 1) kasr shaklida yozilgan: 2.00 · 1,20 · 0.45
	let m = s.match(/(?:^|[^\d.,])(\d{1,2})[.,](\d{1,2})(?![\d])/)
	if (m) {
		const v = Number(m[1] + '.' + m[2])
		if (v >= 0.1 && v <= 5) return v
	}
	// 2) nom boshida: "030/..." — 4 xonali RAL kodi bu yerga tushmaydi
	m = s.match(/^(\d{2,3})[/\s]/)
	if (m) { const v = take(m[1]); if (v) return v }
	// 3) ajratgichdan keyin: /040 · /035 · " 016 " · /04MOK
	m = s.match(/[/\s](\d{2,3})(?![\d.,])/)
	if (m) { const v = take(m[1]); if (v) return v }
	return null
}
